export default __webpack_public_path__ + "static/media/portfolio6.72d1107e.jpg";